import React, { createContext, useCallback, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { LSAuthenticatedContextState, LSAuthenticatedProviderProps } from "./lsAuthenticated.definition";

export const LSAuthenticatedContext = createContext<Partial<LSAuthenticatedContextState>>({});

export const LSAuthenticatedProvider = (props: LSAuthenticatedProviderProps): JSX.Element => {
  const [lsAuthenticated, setLSAuthenticated] = useState(null);
  const [cookie, setCookie, removeCookie] = useCookies(["pathname", "url_search_params"]);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    console.debug("LSAuthenticatedProvider - useEffect - window.location.search: ", window.location.search);
    if (
      window.location.search.length > 0 &&
      !params.has("code") &&
      !params.has("state") &&
      cookie.url_search_params !== window.location.search
    ) {
      setCookie("pathname", window.location.pathname, { path: "/" });
      setCookie("url_search_params", params.toString(), { path: "/" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.search]);
  const logoutCleanup = useCallback(() => {
    removeCookie("pathname");
  }, [removeCookie]);
  const value = { lsAuthenticated, setLSAuthenticated, logoutCleanup };
  return <LSAuthenticatedContext.Provider value={value}>{props.children}</LSAuthenticatedContext.Provider>;
};
